import { makeStyles } from '@material-ui/styles'
import type { ReactNode } from 'react'
import Info from 'core/components/validatedForm/Info'
import Text from 'core/elements/Text'
import type Theme from 'core/themes/model'

const useStyles = makeStyles<Theme>((theme) => ({
  info: {
    background: theme.palette.grey[50],
    marginBottom: theme.spacing(2),
  },
  infoContent: {
    display: 'grid',
    gap: 8,
  },
}))

interface Props {
  title: string
  description: ReactNode
}

// Shared wizard-step header: a bordered Info box with a bold title and a body description —
// previously copy-pasted identically in each Create/Clone VM step (FlavorStep, NetworkingStep,
// CustomizeStep, SourceStep, AttachVolumesStep).
export default function StepTitle({ title, description }: Props) {
  const classes = useStyles()
  return (
    <Info className={classes.info}>
      <div className={classes.infoContent}>
        <Text variant="caption1">{title}</Text>
        <Text variant="body2">{description}</Text>
      </div>
    </Info>
  )
}
